import React from 'react'
import keys from 'lodash/keys'
import isEqual from 'lodash/isEqual'
import { useSelector } from 'react-redux'

import { FormattedMessage } from 'react-intl'
import { Fieldset, CheckBoxPill, Text, Form } from 'src/Components'
import { ADDITIONAL_UPDATE_OPTIONS } from 'src/constants/valuation'
import { selectHomeAdditionalUpdates } from 'src/store/selectors/home/answers'
import NavigationButtons from '../Buttons/NavigationButtons'

import styles from './HomeFactsSteps.module.scss'

const FIELDSET_KEYS = keys(ADDITIONAL_UPDATE_OPTIONS)

const EnterAdditionalUpdates = ({ onBack, onAdditionalUpdates }) => {
  const existingUpdates = useSelector(selectHomeAdditionalUpdates)

  const handleSubmit = (e, updatedFields) => {
    e.preventDefault()
    const isDirty = !isEqual(existingUpdates, updatedFields)

    onAdditionalUpdates(updatedFields, isDirty)
  }

  return (
    <Form
      name='homeFactsUpdates'
      className={styles.homeFactsStep}
      onSubmit={handleSubmit}
      fields={FIELDSET_KEYS}
    >
      <Text
        className={styles.homeFactsHeader}
        size='xl'
        variant='neutralCool'
        variantCount='900'
      >
        <FormattedMessage
          id='TYV.panels.additionalUpdates.head'
          defaultMessage='Have you made any updates since purchasing your home?'
        />
      </Text>
      <Fieldset className={styles.updatesFieldset}>
        {FIELDSET_KEYS.map(key => (
          <CheckBoxPill
            className={styles.updatesPill}
            key={key}
            name={key}
            defaultChecked={!!existingUpdates[key]}
          >
            <FormattedMessage {...ADDITIONAL_UPDATE_OPTIONS[key]} />
          </CheckBoxPill>
        ))}
      </Fieldset>
      <NavigationButtons handleBack={() => onBack(50)} />
    </Form>
  )
}

export default EnterAdditionalUpdates
